import { useEffect, useState } from "react";

export default function PdfModal({ show, handleClose, base64Pdf }) {
  const [pdfUrl, setPdfUrl] = useState("");
function getCleanBase64(base64Pdf) {
  if (base64Pdf.includes(",")) {
    return base64Pdf.split(",")[1]; 
  }
  return base64Pdf;
}

useEffect(() => {
  if (base64Pdf) {
    try {
      const cleanedBase64 = getCleanBase64(base64Pdf);
      const byteCharacters = atob(cleanedBase64);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const file = new Blob([byteArray], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);
      setPdfUrl(fileURL);
      return () => URL.revokeObjectURL(fileURL);
    } catch (err) {
      console.error("Error rendering PDF:", err);
    }
  }
}, [base64Pdf]);

  useEffect(()=>{
console.log(pdfUrl,"pdfUrl")
  },[pdfUrl])
  return (
    <div style={{padding:"10px 10px"}} >
      
        {pdfUrl ? (
     <iframe
  src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
  id="pdfreaderiframe"
  style={{
    
    width: "800px",
    height: "78vh",
    border: "none",
    display: "block",
  }}
  title="PDF Viewer"
/>


        ) : (
          <p>Loading PDF...</p>
        )}
      
      </div>
  );
}
